import { router } from 'expo-router'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Message } from '@/src/elements/message'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { CommonHeader } from '@/src/elements/templates/CommonLayout'
import { Typography } from '@/src/elements/text/Typography'
import { useAccessibilityContext } from '@/src/features/accessibility/context/AccessibilityContext'
import { AccessibilityHiddenTitle } from '@/src/features/accessibility/ui/components/AccessibilityHiddenTitle'
import { TEST_ID } from '@/src/general/constants/testId'
import type { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'
import type { TMessageKey } from '@/src/lang/useTranslate'

type TMailScreenProps = {
  textId: TMessageKey
  icon: ICON
}

export const MailScreen = ({ textId, icon }: TMailScreenProps): ReactNode => {
  const { routes } = useRoutes()
  const { initializeRef } = useAccessibilityContext()
  return (
    <View className="flex-1">
      <CommonHeader contrast />
      <View testID={TEST_ID.MISCELLANEOUS.MAIL_SCREEN_CONTAINER} className="h-full w-full flex-1 items-center gap-4">
        <AccessibilityHiddenTitle
          ref={(ref) => {
            initializeRef(ref, 'main')
          }}
        >
          <FormattedMessage id="app.accessibility.unsubscribe-donation-mail" />
        </AccessibilityHiddenTitle>
        <View className="max-w-[500px] items-center gap-4 p-6">
          <Message iconName={icon} colors="success">
            <FormattedMessage id={textId} />
          </Message>
          <Spacer y={10} />
          <Typography>
            <FormattedMessage id="word.whats-next" />
          </Typography>
          <Button colors="primary" variant="solid" onPress={() => router.replace(routes.intentionsForm())}>
            <FormattedMessage id="intention.page.button" />
          </Button>
          <Button colors="primary" variant="solid" onPress={() => router.replace(routes.intentions())}>
            <FormattedMessage id="intention.pray-for" />
          </Button>
        </View>
      </View>
    </View>
  )
}
